import { getUserInfo } from "./firestoreModelUser";
import { doc, getDoc } from "firebase/firestore";
import { getClubInfo } from "./firestoreModelClub";


export async function fillMemberInfo(membersFirebase) {
  console.log("members from firebase:", membersFirebase);
  if(!Array.isArray(membersFirebase)){
    return;
  }
  // Funktion som hämtar och fyller info för en medlem
  function addUserInfoCB(member) {
    return getUserInfo(member.userId)
      .then(user => {
        
        return {
          userId: member?.userId ?? null,
          name: user?.username ?? null,
          profileImg: user?.userIMG ?? null,
          readingProgress: member?.readingProgress ?? 0
        };
      })
      .catch(error => {
        console.error("Error during member info merge:", error);
      });
  }

  const filledMembers = await Promise.all(membersFirebase.map(addUserInfoCB));
  console.log("Filled members info:", filledMembers);
  return filledMembers;
}

export async function fillPendingRequestInfo(pendingUsers){
  if(!Array.isArray(pendingUsers)){
    return;
  }
  function addUserInfoCB(pendingUser) {

    return getUserInfo(pendingUser)
      .then(user => {
        return {
          userId: pendingUser?? null,
          name: user?.username ?? null,
          profileImg: user?.userIMG ?? null,
        };
      })
      .catch(error => {
        console.error("Error during member info merge:", error);
      });
  }

  return Promise.all(pendingUsers.map(addUserInfoCB))
    .then(filledUsers => {
      console.log("Filled members info:", filledUsers);
      return filledUsers;
    });
}

export async function fillClubInfo(pendingClubs) {
  if(!Array.isArray(pendingClubs)){
    return;
  }
  async function addClubInfoCB(pendingClub) {
    console.log("pending club", pendingClub)
    const club = await getClubInfo(pendingClub)
    console.log("clubinfo",club)
    
    return{
      clubId: pendingClub ?? null,
      name: club?.clubName ?? null,
      genre: club?.genre ?? null,
      nofMembers: club?.members.length ?? 0,
    } 
  }

  return await Promise.all(pendingClubs.map(addClubInfoCB))
}


export async function makeUserObj(uid){
  if (!uid || (typeof uid === "string" && uid.trim() === "")) {
    console.error("makeUserObj: Invalid uid", { uid });
    return null;
  }
  const snapshot = await getDoc(doc(db, "users", uid));
    const user = snapshot.data();
    console.log(user);
    
    return {
    uid: user?.uid ?? null,
    userName: user?.username ?? null,
    email: user?.email ?? null,
    userClubs: user?.clubs ?? [],
    userIMG: user?.userIMG ?? null,
    }
}
